import Container from './AttributeBatchEdit.container';
import AttributeBatchEdit from './AttributeBatchEdit';

export default Container(AttributeBatchEdit);
